export default () => '/tracking';
